import React, {useEffect, useState} from 'react'
import Footer from '../../components/Footer'
import Navbar from "../../components/Navbar"
import PreNav from "../../components/PreNav"
import Card from '../../components/Products/Card'
import {useDispatch, useSelector} from 'react-redux'
import { getProducts } from '../../redux/actions/productActions'
import Loading from '../util/Loading'

const Products = () => {

  const theme = [
    {name:"Animal", query:"animal"},
    {name:"Anime", query:"anime"},
    {name:"Artist", query:"artist"},
    {name:"Boho", query:"boho"},
    {name:"Famous Artwork", query:"famous_artwork"},
    {name:"Fantasy", query:"fantasy"},
    {name:"Floral", query:"floral"},
    {name:"Football", query:"football"},
  ]

  const dispatch = useDispatch()
  const {error, products, productsCount} = useSelector(state=>state.products)
  const [currentPage, setCurrentPage] = useState(1)
  const [query, setQuery] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (products.length===0) {
      dispatch(getProducts(currentPage))
      .then(res=>{
        setLoading(false)
      })
    }
  }, [])

  const handleLoadMore = (e) => {
    e.preventDefault()
    dispatch(getProducts(currentPage+1))
    .then(res=>{
      setCurrentPage(currentPage+1)
    })
  }

  return (
    loading ? <Loading/> : <>
      <PreNav/>
      <Navbar/>
      <section className="py-11">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-3">
              {/* Filters */}
                <ul className="nav nav-vertical" id="filterNav">
                  <li className="nav-item">
                    {/* Toggle */}
                    <a className="nav-link font-size-lg text-reset border-bottom mb-6">Theme</a>
                    {/* Collapse */}
                    <div className="">
                      <div className="form-group">
                        <ul className="list-styled mb-0" id="productsNav">
                          {theme.map((item, index)=>(
                            <li className="list-styled-item" key={index}><a className="list-styled-link">{item.name}</a></li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
            </div>
            <div className="col-12 col-md-8 col-lg-9">
              <div className="row align-items-center mb-7">
                <div className="col-12 col-md">
                  {/* Heading */}
                  <h3 className="mb-1">Framed Art</h3>
                  {/* Breadcrumb */}
                  <ol className="breadcrumb mb-md-0 font-size-xs text-gray-400">
                    <li className="breadcrumb-item">
                      <a className="text-gray-400" href="/">Home</a>
                    </li>
                    <li className="active">
                      <i className='bi bi-chevron-right px-3'></i>
                      Framed Art
                    </li>
                  </ol>
                </div>
                <div className="col-12 col-md-auto">
                  {/* Select */}
                  <select className="custom-select custom-select-xs">
                    <option value="newestfirst">Featured</option>
                    <option value="newestfirst">Best selling</option>
                    <option value="newestfirst">Alphabetically, A-Z</option>
                    <option value="newestfirst">Alphabetically, Z-A</option>
                    <option value="newestfirst">Price, low to high</option>
                    <option value="newestfirst">Price, high to low</option>
                    <option value="newestfirst">Date, old to new</option>
                    <option value="newestfirst">Date, new to old</option>
                  </select>
                </div>
              </div>
              {/* Tags */}
              <div className="row">
                {products.map((item, index)=>(
                  <div className="col-6 col-md-4" key={index}>
                    <Card details={item} />
                  </div>
                ))}
              </div>
                <div className='d-flex justify-content-center align-items-center flex-column'>
                <p>Showing {products.length} of {productsCount} items</p>
                {products.length < productsCount && 
                  <button className='btn btn-dark px-10' onClick={(e)=>handleLoadMore(e)}>Load More Products</button>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default Products